export const ADD_NOTIFICATION = 'addNotification'
export const MARK_ALL_NOTIFICATIONS_AS_READ = 'markAllNotificationsAsRead'
export const MARK_NOTIFICATION_AS_READ = 'markNotificationAsRead'
export const REMOVE_ALL_NOTIFICATIONS = 'removeAllNotifications'
export const REMOVE_NOTIFICATION = 'removeNotification'
export const SET_NOTIFICATIONS = 'setNotifications'
